import React from 'react';
import UpgradeExpensesContainer from './UpgradeExpensesAUContainer';
import ExpensesContainer from './ExpensesAUContainer';
import { useApplicationFlags } from 'hooks/useApplicationFlags';


const ExpensesAUContainer = () => {
  const { isOcmOrUpgrade } = useApplicationFlags()

  return (
    isOcmOrUpgrade
      ? <UpgradeExpensesContainer />
      : <ExpensesContainer />
  );
}

export default ExpensesAUContainer;
